module.exports = __webpack_public_path__ + "static/extension-suggestions-d0ac3259063e4685c3d70de864fe2d7a.png";